<div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
    <ng-container *transloco="let t; prefix: 'requisiton'">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title" id="newSchemaModalLabel">{{ t("title") }}</h4>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
                    (click)="onClose()"></button>
            </div>
            <div class="modal-body">
                <ng-container *ngIf="requisitionIsSent() === false; else requisitionIsSentContent">
                    <form [formGroup]="requisitionForm" class="was-validated" id="orderSchemaForm">
                        <h5> {{ t("patientsectiontitle") }} </h5>
                        <div class="row g-2 mb-3">
                            <div class="col-sm-12">
                                <div class="input-group">
                                    <span class="input-group-text">{{ t('ssn') }}</span>
                                    <input type="text" class="form-control" id="cprNumber"
                                        formControlName="cprNumber"
                                        [maxLength]="10"
                                        [class.is-invalid]="patientExists() === false"
                                        [class.is-valid]="patientExists() === true"
                                        (keydown.enter)="onEnterPressed()"
                                        autocomplete="off"
                                        required>
                                </div>
                                <div class="form-text" id="basic-addon4">{{ t('cprinputplaceholder') }}</div>
                            </div>
                            <div class="col-sm-6">
                                <label for="firstName" class="form-label">{{ t("firstname") }}</label>
                                <input type="text" class="form-control" id="firstName" formControlName="firstName"
                                    [maxLength]="50" autocomplete="off" required readonly>
                            </div>
                            <div class="col-sm-6">
                                <label for="lastName" class="form-label">{{ t("lastname") }}</label>
                                <input type="text" class="form-control" id="lastName" formControlName="lastName"
                                    [maxLength]="50" autocomplete="off" required readonly>
                            </div>
                            <div class="col-sm-6">
                                <label for="sms" class="form-label">SMS</label>
                                <input type="tel" class="form-control" id="sms" formControlName="sms" [maxLength]="15"
                                    autocomplete="off">
                            </div>
                            <div class="col-sm-6">
                                <label for="email" class="form-label">E-mail</label>
                                <input type="email" class="form-control" id="email" formControlName="email"
                                    [maxLength]="50" autocomplete="off">
                            </div>
                        </div>
                        <h5>{{ t("schemasectiontitle") }}</h5>
                        <div class="row g-2 mb-3">
                            <div class="col-sm-12">
                                <label for="schemaGuid" class="form-label">{{ t("schema") }}</label>
                                <select class="form-select" aria-label="Schema list" id="schemaGuid"
                                    formControlName="schemaGuid" required>
                                    <option *ngFor="let schemaType of schemaTypes" [value]="schemaType.schemaGuid">
                                        {{schemaType.name}}
                                    </option>
                                </select>
                            </div>
                            <div class="col-sm-6">
                                <label for="validFrom" class="form-label">{{ t("validfrom") }}</label>
                                <input type="date" class="form-control" id="validFrom" formControlName="validFrom"
                                    autocomplete="off" required>
                            </div>
                            <div class="col-sm-6">
                                <label for="validTo" class="form-label">{{ t("validto") }}</label>
                                <input type="date" class="form-control" id="validTo" formControlName="validTo"
                                    autocomplete="off" required>
                            </div>
                        </div>
                        <h5>{{ t("clinicsectiontitle") }}</h5>
                        <div class="row g-2 mb-3">
                            <div class="col-sm-4">
                                <label for="providerNumber" class="form-label">{{ t("providerno") }}</label>
                                <input type="text" class="form-control" id="providerNumber"
                                    formControlName="providerNumber" readonly>
                            </div>
                            <div class="col-sm-4">
                                <label for="organisation" class="form-label">{{ t("organisation") }}</label>
                                <input type="text" class="form-control" id="organisation" formControlName="organisation"
                                    readonly>
                            </div>
                            <div class="col-sm-4">
                                <label for="initials" class="form-label">{{ t("initials") }}</label>
                                <input type="text" class="form-control" id="initials" formControlName="initials"
                                    [maxLength]="10" autocomplete="off" required>
                            </div>
                        </div>
                        <h5>{{ t("notifications") }}</h5>
                        <div class="row g-2">
                            <div class="col-12">
                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox" value="" id="notifySender"
                                        formControlName="notifySender">
                                    <label class="form-check-label d-flex" for="notifySender">
                                        {{ t("notifysender") }}
                                    </label>
                                </div>
                            </div>
                            <div class="col-12">
                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox" value="" id="notifyPatient"
                                        formControlName="notifyPatient">
                                    <label class="form-check-label d-flex" for="notifyPatient">
                                        {{ t("notifypatient") }}
                                    </label>
                                </div>
                            </div>
                        </div>
                    </form>
                </ng-container>
                <ng-template #requisitionIsSentContent>
                    <div class="row">
                        <div class="col-auto m-auto">
                            <svg class="icon-success icon-lg">
                                <use xlink:href="assets/icons.svg#icon-circle-check"></use>
                            </svg>
                        </div>
                        <div class="col ms-auto p-0">
                            <span class="text-success-emphasis">{{ t("infolog.success")}}</span>
                        </div>
                    </div>
                </ng-template>
            </div>

            <div class="modal-footer">
                <ng-container *ngIf="requisitionIsSent() === false && requisitionSendError() === true">
                    <div class="row w-100">
                        <div class="col-auto m-auto">
                            <svg class="icon-danger icon-lg">
                                <use xlink:href="assets/icons.svg#icon-circle-x"></use>
                            </svg>
                        </div>
                        <div class="col m-auto p-0">
                            <span class="text-danger-emphasis">{{ t("infolog.error")}}</span>
                        </div>
                    </div>
                </ng-container>

                <ng-container *ngIf="requisitionIsSent() === false">
                    <button type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal" (click)="onClose()">
                        {{ t("cancel") }}
                    </button>
                    <button type="submit" class="btn wp-btn" (click)="onOrderRequisitionClick()">
                        {{ t("order" )}}
                    </button>
                </ng-container>
                <ng-container *ngIf="requisitionIsSent() === true">
                    <button type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal" (click)="onClose()">
                        {{ t("close") }}
                    </button>
                </ng-container>
            </div>
        </div>
    </ng-container>
</div>